angular
    .module("contatti.components", [])
    .component("contatti", {
        templateUrl: "ng/components/contatti/contatti.view.html",
        bindings: {
            model: "=",
            exportValidity: '&'
        },
        controller: ContattiController,
        controllerAs: "contattiCtrl"
    })

function ContattiController(
    $scope,
    $timeout
) {
    var self = this;

    self.$onInit = function () {
        $timeout(function () {
            verifyComponent();
        }, 500)
    }

    self.handleChange = function () {

        verifyComponent();
    }

    var verifyComponent = function () {

        console.log($scope.contrattoForm.$valid)
        self.exportValidity({ value: $scope.contrattoForm.$valid })
    }
}